<template>
<div id="details">
    <div v-if="currentProduct" class=" flex-column text-lg-left text-md-center">
        <h1 class="home-title">{{ currentProduct.name }}</h1>
        <div class="row product-select-box w-100 mb-3 d-flex justify-content-between">
            <div class="col-12 py-3">
                <button @click="isAboutProductOpen = !isAboutProductOpen" class="btn btn-link d-block w-100 noto-sans-14 text-left font-wight-500 text-uppercase font-16" data-toggle="collapse" data-target="#collapse-about-product">
                    <span class="link-heading text-uppercase">{{isDiamond ? 'About the diamond' : 'About the ring style'}}</span>
                    <span class="float-right icon">{{ isAboutProductOpen ? '-' : '+' }}</span>
                </button>
            </div>
            <div id="collapse-about-product" class="text-left collapse m-0" :class="{'show': isAboutProductOpenIndicator}">
                <div class="diamond-data" v-if="isDiamond">
                    <div v-if="currentProduct.SKU" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">SKU</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.SKU }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.Lab" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Certificate</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.Lab }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.Shape" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Shape</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.Shape }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.Weight" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Weight</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.Weight }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.Color" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Color</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.Color }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.Clarity" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Clarity</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.Clarity }}</div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Cut</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{translateCPS(currentProduct.Cut)}}</div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Symmetry</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{translateCPS(currentProduct.Symmetry)}}</div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Polish</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{translateCPS(currentProduct.Polish)}}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.Measurements" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Measurements</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.Measurements }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.Depth " class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Depth</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.Depth }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.Table " class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Table</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.Table }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.internal_lot " class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Lot number</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.internal_lot }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.FlourIntensity " class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Fluorescence</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ getFluorescenceDictionary }}</div>
                        </div>
                    </div>
                </div>
                <div class="ring-data" v-if="!isDiamond">
                    <div v-if="currentProduct.ringShape" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Shape</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.ringShape }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.diamShape" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Diamond</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.diamShape }}</div>
                        </div>
                    </div>
                    <div v-if="currentProduct.ringColor" class="row mb-4">
                        <div class="col-7 col-lg-5">
                            <div class="font-weight-bold">Color</div>
                        </div>
                        <div class="col-5 col-lg-7">
                            <div>{{ currentProduct.ringColor }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="price place mb-3" v-if="currentProduct.TotalPrice">
            <h2 class="home-title text-left price-tag">{{ useFromNumToPrice(currentProduct.TotalPrice) }}</h2>
            <span class="d-block w-100 noto-sans-14 text-left">estimated price*</span>
        </div>
        <button aria-label="Schedule an appointment" class="btn rnd-primary-btn mb-3 main-btn text-uppercase" @click="addToWishlist">{{buttonCaption}}</button>
        <div v-if="!hidden" class="product-btns-box w-100 pt-3 pb-3 d-flex">
            <div class="flex-fill">
                <button class="btn btn-link p-0">
                    <img class="icon-img" alt="heart" src="../../../assets/images/icons/email.svg">
                    <span class="ml-1 align-middle noto-sans-14 text-left font-wight-500 desktop-element">Email a Friend</span>
                </button>
            </div>
        </div>
        <div v-if="!hidden && currentStore && currentStore.companyName" class="row product-select-box w-100 pt-3 pb-3 d-flex justify-content-between mb-5">
            <div class="col-12">
                <button @click="isAboutStoreOpen = !isAboutStoreOpen" class="btn btn-link d-block w-100 noto-sans-14 text-left font-wight-500 text-uppercase font-16" data-toggle="collapse" data-target="#collapse-about-store">
                    <span class="link-heading">{{`WHY ${currentStore.companyName}`}}</span>
                    <span class="float-right icon">{{ isAboutStoreOpen ? '-' : '+' }}</span>
                </button>
            </div>
            <div id="collapse-about-store" class="text-left collapse m-0 col-12">
                <div class="col-12">
                    <div class="row">
                        <div class="col-12 col-lg-7 pl-0">
                            <div class="advantage-area">
                                <img src="../../../assets/images/icons/check.svg" class="mail-icon mr-1">
                                <span class="align-middle">Ethically Sourced </span>
                            </div>
                            <div class="advantage-area">
                                <img src="../../../assets/images/icons/check.svg" class="mail-icon mr-1">
                                <span class="align-middle">Free Shipping to Store</span>
                            </div>

                        </div>
                        <div class="col-12 col-lg-5 pl-0 pl-0 pr-0">
                            <div class="advantage-area">
                                <img src="../../../assets/images/icons/check.svg" class="mail-icon mr-1">
                                <span class="align-middle">No Commitment</span>
                            </div>
                            <div class="advantage-area">
                                <img src="../../../assets/images/icons/check.svg" class="mail-icon mr-1">
                                <span class="align-middle">GIA Certified</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex';
import {
    fromNumToPrice
} from "../../helpers";

export default {
    name: 'product-details',
    props: ['currentProduct', 'currentStore'],
    data() {
        return {
            isAboutProductOpenIndicator: window.innerWidth > 991,
            isAboutProductOpen: window.innerWidth > 991,
            isAboutStoreOpen: false,
            hidden: true
        }
    },
    computed: {
        ...mapGetters('willyou', [
            'wishlistLink',
            'startWithRingLink',
            'startWithDiamondLink',
            'chosenDiamond',
            'chosenRing',
        ]),
        ...mapState('willyou', [
            'storeMode',
            'isDiamondsPage',
            'wishlist',
            'storeMode'
           ]),
        isStoreMode() {
            return this.storeMode===true;
        },
        isStore() {
            return this.currentStore && this.currentStore.companyName && this.currentStore.companyName!=='Willyou.net';
        },
        storeWithTou() {
            return this.isStore && this.currentStore.onlyLead===false;
        },
        insideStore() {
            return typeof this.$route.params.url !== 'undefined';
        },
        isDiamond() {
            return typeof this.currentProduct.Clarity !== 'undefined';
        },
        isStoreMode() {
            return this.storeMode === true && !this.isDiamondsPage;
        },
        isRingsPage () {
          return   this.$route.name === 'engagement-rings-search-product-ring' || this.$route.name ==='product-ring';
        },
        buttonCaption() {
            if ( !this.isStore && this.isRingsPage ) return 'Find at a Local Jeweler';   // Diamonds page
            if ( !this.isStore && this.isDiamond ) return 'Find at a Local Jeweler';     // Rings page
            if ( this.isStore && this.storeWithTou ) return 'Contact Jeweler';   // Jeweler+TOU 
            if ( this.isStore && !this.storeWithTou ) return 'Contact Jeweler';   // Jeweler-!TOU 
            if ( this.isStoreMode ) return 'Contact Jeweler';   // Live diamond feed page 

            return '';
        },
        nextLocation() {
            if (this.isStoreMode) {
                return {
                    name: 'schedule-popup'
                };
            }

            if( this.$route.name==='diamond-popup' || this.$route.name==='product-diamond') {
                return {name: 'jeweler-schedule-popup'}
            }
            if(this.$route.name==='diamonds-page-diamond-popup') {
                return {name: 'diamonds-page-schedule-popup'}
            }
            if (this.chosenDiamond && this.chosenRing) {
                return this.wishlistLink;
            } else if (this.chosenDiamond) {
                return {name: 'jeweler-schedule-popup'};
            } else {
                return this.startWithDiamondLink;
            }
        },
        getFluorescenceDictionary() {
            switch (this.currentProduct.FlourIntensity.toUpperCase()) {
                case 'N':
                    return 'None';
                case 'F':
                    return 'Faint';
                case 'FB':
                    return 'Faint Blue';
                case 'M':
                    return 'Medium'; 
                case 'MB':
                    return 'Medium Blue';
                case 'SB':
                    return 'Strong Blue';
                case 'VS':
                    return 'Very Strong';
                case 'S':
                    return 'Strong';
                default: 
                    return this.currentProduct.FlourIntensity.toUpperCase();
            }
        },
    },
    methods: {
        ...mapActions('willyou', [
            'addProductToWishlist',
        ]),
        addToWishlist() {
            this.addProductToWishlist(this.currentProduct);

            if(this.isRingsPage) {
                this.$emit('schedule');
            }else{
                this.$router.push(this.nextLocation);
            }
        },
        useFromNumToPrice(n) {
            return fromNumToPrice(n);
        },
        translateCPS(input) {
            switch (input.toUpperCase()) {
                case "EX":
                    return "Excellent";
                case "VG":
                    return 'Very Good';
                case "G":
                    return "Good";
                case "F":
                    return "Fair";
                case "P":
                    return "Poor";
                default:
                    return "-";
            }
        }
    },
}
</script>

<style lang="scss" scoped>
#details {
    .font-16 {
        font-size: 16px;
    }

    .main-btn {
        height: 48px;
    }

    .product-select-box {
        border: solid 0 #d6d6d6;
        border-top-width: 1px;
        border-bottom-width: 1px;
    }

    .product-btns-box {
        border: solid 0 #d6d6d6;
        border-top-width: 1px;
    }

    .price-tag {
        font-size: 24px;
    }

    #collapse-about-product,
    #collapse-about-store {
        padding-left: 30px;
    }

    .link-heading {
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #4a4a4a;
        font-size: 16px;
        margin-top: 30px;
        display: inline;
    }

    @media (max-width: 767px) {
        .icon-img {
            display: block;
            margin: auto;
        }
    }
}
</style>
